<template>
    <b-form-group
        :label="`${attribute.name}${attribute.required ? ' * (Zorunlu)' : ''}`"
        :class="{ 'border border-danger rounded p-1': missingRequired }"
        :label-class="missingRequired ? 'text-danger' : null"
        :state="missingRequired ? false : null"
        invalid-feedback="Bu zorunlu özellik için bir değer seçin veya girin."
    >
        <b-form-input
            v-if="attribute.allow_custom"
            :value="customInputValue"
            maxlength="255"
            :disabled="disabled"
            :state="missingRequired ? false : null"
            :aria-label="`${attribute.name} serbest metin`"
            @input="custom"
        />
        <template v-else>
            <v-select
                :value="selectedOption"
                :options="options"
                label="name"
                :filterable="false"
                :disabled="disabled"
                :input-id="`attribute-${attribute.attribute_id}`"
                placeholder="Değer ara veya seç"
                @search="search"
                @open="load(1)"
                @input="select"
            >
                <template #no-options>
                    {{ loading ? 'Yükleniyor…' : (error ? 'Değerler yüklenemedi.' : 'Yerel katalogda değer bulunamadı.') }}
                </template>
                <template #list-footer>
                    <li
                        v-if="total > limit"
                        class="p-1"
                        @mousedown.prevent
                    >
                        <b-pagination
                            :value="page"
                            :total-rows="total"
                            :per-page="limit"
                            size="sm"
                            :disabled="loading"
                            @input="load"
                        />
                    </li>
                </template>
            </v-select>
            <small
                v-if="loading"
                role="status"
            >Değerler yükleniyor…</small>
        </template>
        <b-button
            v-if="selection.value_id != null || selection.custom_value"
            size="sm"
            variant="link"
            :disabled="disabled"
            @click="clear"
        >
            Seçimi temizle
        </b-button>
        <div
            v-if="error"
            class="text-danger"
            role="alert"
        >
            {{ error }} <b-button
                size="sm"
                variant="link"
                @click="load(page)"
            >
                Tekrar dene
            </b-button>
        </div>
        <div
            v-for="message in errors"
            :key="message"
            class="text-danger"
            role="alert"
        >
            {{ message }}
        </div>
    </b-form-group>
</template>
<script>
    import {
        BFormGroup, BFormInput, BButton, BPagination,
    } from 'bootstrap-vue'
    import vSelect from 'vue-select'
    import { errorMessage } from '@/store/v2/trendyol/management'

    export default {
        components: {
            BFormGroup, BFormInput, BButton, BPagination, vSelect,
        },
        props: {
            attribute: { type: Object, required: true },
            categoryId: { type: Number, required: true },
            disabled: { type: Boolean, default: false },
            errors: { type: Array, default: () => [] },
        },
        data() {
            return {
                options: [],
                query: '',
                page: 1,
                total: 0,
                limit: 20,
                loading: false,
                error: '',
                version: 0,
                timer: null,
            }
        },
        computed: {
            selection() { return this.attribute.selection || {} },
            missingRequired() {
                return this.attribute.required && this.selection.value_id == null && !(this.selection.custom_value || '').trim()
            },
            customInputValue() {
                return this.selection.custom_value != null ? this.selection.custom_value : (this.selection.value_name || '')
            },
            selectedOption() {
                return this.selection.value_id == null ? null : { ty_id: this.selection.value_id, name: this.selection.value_name || `Değer #${this.selection.value_id}` }
            },
        },
        beforeDestroy() { clearTimeout(this.timer); this.version += 1 },
        methods: {
            clear() { this.$emit('change', null) },
            custom(value) { this.$emit('change', { custom_value: value, value_id: null, value_name: null }) },
            select(value) { this.$emit('change', value ? { value_id: value.ty_id, value_name: value.name, custom_value: null } : null) },
            search(query) {
                this.query = query
                clearTimeout(this.timer)
                this.version += 1
                this.timer = setTimeout(() => this.load(1), 350)
            },
            async load(page) {
                clearTimeout(this.timer)
                this.version += 1
                const { version } = this
                this.page = page
                this.loading = true
                this.error = ''
                try {
                    const result = await this.$store.dispatch('tyManagement/loadValues', {
                        categoryId: this.categoryId,
                        attributeId: this.attribute.attribute_id,
                        params: { q: this.query, page, limit: this.limit },
                    })
                    if (version !== this.version) return
                    this.options = result.data
                    this.total = result.total
                } catch (error) {
                    if (version === this.version) this.error = errorMessage(error)
                } finally {
                    if (version === this.version) this.loading = false
                }
            },
        },
    }
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
